import React from "react";
import {Button, Dialog, DialogTitle} from "@material-ui/core/";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "@material-ui/icons/Close";
import PropTypes from "prop-types";

const Modal = ({children, setOpen, title, minWidth}) => {

    const handleClose = () => {
       setOpen(false)
    }

    return (
        <Dialog
            id="autommate-modal"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    overflowX: "hidden",
                    minWidth: minWidth ? minWidth : 400,
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    <b>{title}</b>
                    <Button>
                        <Close onClick={handleClose}/>
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingLeft: 20, paddingRight: 10}}>
                {children}
            </DialogContent>
        </Dialog>
    );
};

Modal.propTypes = {
    children : PropTypes.any,
    setOpen : PropTypes.func,
    title: PropTypes.string,
    minWidth: PropTypes.any
}
export default Modal

